<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"></i>
					{{ $t('Печать')}}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="doc-body">
			<b-card class="p-3">
				<div class="text-center mb-3">
					<h4 class="font-weight-bold text-uppercase" style="color: blue;">АКТ СВЕРКИ <br>
						<span class="small">расчеты с контрагентом по договору Договор №
							<input placeholder="" type="text" class="bottomBorderedInput borderBlue"/> за период<br>
							 {{ saldoByYear.currentYear.year }} г.
						</span>
					</h4>
				</div>
				<b-row class="mb-3">
					<b-col cols="12" id="saldoAktDefinition">
						Мы, нижеподписавшиеся главный бухгалтер
						<input
							:value="currentDepartmentForMoneyTransfer.accountantFullName"
							placeholder="" type="text"
							class="bottomBorderedInput"
							onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/>
						<strong>{{currentDepartmentForMoneyTransfer.name }}</strong> с одной стороны, и
						<strong>{{ currentContragentForTransfer.fullName }}</strong>
						с другой стороны, составили настоящий акт-сверки на <input placeholder="" type="text" class="bottomBorderedInput forDate borderDefault" onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/>
																				   {{ saldoByYear.currentYear.year }} г.
					</b-col>
				</b-row>
				<div class="saldoTable mb-3">
					<table class="table table-striped" id="gridContainer">
						<thead>
						<tr>
							<th class="p-1" rowspan="2">{{$t('incomes.date')}}</th>
							<th class="p-1" rowspan="2">Наименование операции</th>
							<th class="p-1" rowspan="2">Номер чека</th>
							<th class="p-1" colspan="2">{{ currentContragentForTransfer.fullName }}</th>
							<th class="p-1" rowspan="2">{{ $t('actions.title') }}</th>
						</tr>
						<tr>
							<th class="p-1" style="color: red">Қарз</th>
							<th class="p-1" style="color: green">Пул олиш</th>
						</tr>
						</thead>
						<tbody>
						<tr class="saldoList" v-for="el in saldoByYear.saldoList">
							<td>{{ el.aktDate }}</td>
							<td>{{ el.operation }}</td>
							<td>{{ el.saleNumber }}</td>
							<td>
								<span v-if="el.creditContragent">
									{{ el.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}
								</span>
							</td>
							<td style="color: green; font-weight: bold">
								<span v-if="el.debitContragent">
									{{ el.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}
								</span>
							</td>
							<td @click="sale(el)" style="cursor: pointer" >
								<i v-if="el.saleNumber" class="fa fa-eye editBtn"></i>
							</td>
						</tr>
						<tr class="totalSaldo strong">
							<td colspan="3">Умумий қарз {{ saldoByYear.totalSaldo.year }} г.</td>
							<td>
								<span v-if="saldoByYear.totalSaldo.debitContragent">
									{{ saldoByYear.totalSaldo.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}
								</span>
							</td>
							<td>
								<span v-if="saldoByYear.totalSaldo.creditContragent">
									{{ saldoByYear.totalSaldo.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}
								</span>
							</td>
							<td></td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="mb-3 mt-5" >
					<div class="d-flex" style="color: red;">
						<p class=""><strong>Сальдо на <input placeholder="" type="text" class="bottomBorderedInput forDate borderRed" onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/> {{ saldoByYear.currentYear.year }} г. в
							сумме <br>Қарздор : {{ inFavorWhom }} </strong></p>
					</div>
					<div style="font-size: 25px">
						<b >Остатка:</b>
						<span v-if="saldoByYear.totalSaldo.debitContragent">{{ saldoByYear.totalSaldo.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</span>
						<span v-if="saldoByYear.totalSaldo.creditContragent">{{ saldoByYear.totalSaldo.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</span>
					</div>

				</div>
				<b-row style="display: flex; justify-content: right">
						<b-button v-if="saldoByYear.saldoList.length > 0" class="hidden-print float-right mt-1" @click="excelExport1('gridContainer', 'АКТ СВЕРКИ')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
				</b-row>
			</b-card>
			<b-modal v-model="show" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true">
				<div class="container">
					<b-row>
						<b-col>
							<b>Дата:</b> &nbsp;<span>{{saleList.updateDate}}</span>
						</b-col>
						<b-col>
							<b>Контрагент:</b> &nbsp; <span>{{saleList.contragentName}}</span>
						</b-col>
					</b-row>
					<br>
					<b-row>
						<table class="table table-striped">
							<thead>
								<tr>
									<th class="text-center">№</th>
									<th class="text-center">{{ $t('restaurant.product') }}</th>
									<th class="text-center">{{ $t('goods.special-barcode') }}</th>
									<th class="text-center">{{ $t('sale.kol-vo') }}</th>
									<th class="text-center">{{ $t('Цена') }}</th>
									<th class="text-center">{{ $t('promo-to-product.discount-price') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(list,index) in saleList.saleItems" :key="index">
									<td class="text-center">{{index+1}}</td>
									<td class="text-center">{{list.name}}</td>
									<td class="text-center">{{list.barcode}}</td>
									<td class="text-center">{{list.count}}</td>
									<td class="text-center">{{list.priceUzs}}</td>
									<td class="text-center">{{list.discountPriceUzs}}</td>
								</tr>
							</tbody>
						</table>
					</b-row>
				</div>
			</b-modal>
		</div>
	</b-container>
</template>

<script>
	import TokenService from "../../../services/storage.service";
	// import moment from 'moment'
	import {mapState} from 'vuex'
	import PosReportService from "@/services/pos.report.service";
	// import CreateForm from "../blocks/CreateForm";
	export default {
		name: 'ShowSaldo',

		data() {
			return {
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0
				},
				show:false,
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
				saleList:[],
			}
		},
		beforeRouteEnter (to, from, next) {
			if(localStorage.getItem('isContragent')) {
				if(to.params.id == localStorage.getItem('contragent_id') ){
					next()
				}else {
					next('/dashboard')
				}
			}else {
				next()
			}
		},
		methods: {
			goBackToFrom() {
				this.$router.back();
			},
			excelExport1(tableID, filename = '') {
				let uri = 'data:application/vnd.ms-excel;base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
					base64 = function(s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					},
					format = function(s, c) {
						return s.replace(/{(\w+)}/g, function(m, p) {
							return c[p];
						})
					}
				let toExcel = document.getElementById(tableID).innerHTML;
				let ctx = {
					worksheet: name || '',
					table: toExcel
				};
				let link = document.createElement("a");
				link.download = `${filename}.xls`;
				link.href = uri + base64(format(template, ctx))
				link.click();
			},
			print() {
				window.print();
			},
			sale(data){
				this.show = true
				PosReportService.getSaleBySaleId(data.saleId).then(res=>{
					this.saleList = res.data
					console.log(this.saleList)
				})
			}
		},
		created() {
		},
		computed: {
			...mapState('contragents', [
				'saldoByYear',
				'currentDepartmentForMoneyTransfer',
				'currentContragentForTransfer'
			]),
			inFavorWhom() {
				if (this.saldoByYear.totalSaldo.debitContragent) {
					return this.currentContragentForTransfer.fullName;
				} else if (this.saldoByYear.totalSaldo.debitDepartment) {
					return this.currentDepartmentForMoneyTransfer.name;
				} else {
					return ''
				}
			},
		},
		components: {},
	}
</script>

<style scoped lang="scss">
	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
	}

	.saldoInfoTexts {
		width: 88%;

		span {
			display: inline-block;
			width: 18%;
		}

		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 80%;
		}

		/*input.bottomBorderedInput:focus {
		border-color: green
		}*/
	}

	.signsOfAccountants {
		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 40%;
		}

		p {
			width: 40%;

			&.sign {
				text-align: center;
				font-size: 12px;
			}
		}
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.borderBlue {
			width: 70px;
			border-color: blue;
			color: blue;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	.saldoTable {
		.table {
			td, th {
				text-align: center;
				vertical-align: middle;
			}

			th {
				font-size: 14px;
			}

			td {
				font-size: 12px;
			}
		}
	}

	.strong {
		font-weight: bold;
	}

</style>















































































































<!--bu kerakli narsa uchirma-->


<!--<template>-->
<!--	<b-container class="show-document">-->
<!--		<div class="actions mb-2 mt-2 hidden-print">-->
<!--			<div class="pull-left">-->
<!--				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')-->
<!--					}}-->
<!--				</b-button>-->
<!--			</div>-->
<!--			<div class="pull-right">-->
<!--				&lt;!&ndash;<b-button-->
<!--					variant="outline-primary"-->
<!--					@click="excelExport('whDocTable', item.regNumber)"-->
<!--					class="mr-2"-->
<!--					v-if="item.action === 'KIRIM'"-->
<!--				>-->
<!--					{{ $t('скачать Excel файл') }}-->
<!--				</b-button>&ndash;&gt;-->
<!--				&lt;!&ndash;<b-button-->
<!--					variant="outline-dark"-->
<!--					@click="generateBarcode"-->
<!--					class="mr-2"-->
<!--					v-if="item.action === 'KIRIM'"-->
<!--				>-->
<!--					<i class="fa fa-print"></i>-->
<!--					Печать Штрихкод-->
<!--				</b-button>&ndash;&gt;-->
<!--				<b-button-->
<!--					variant="outline-dark"-->
<!--					@click="print"-->
<!--					class="mr-2"-->
<!--				>-->
<!--					<i class="fa fa-print"></i>-->
<!--					{{ $t('Печать')}}-->
<!--				</b-button>-->
<!--				&lt;!&ndash;<b-button-->
<!--					v-if="item.editable"-->
<!--					@click="openSidebar"-->
<!--					variant="outline-dark"-->
<!--					class="mr-2"-->
<!--				>-->
<!--					<i class="fa fa-edit"></i>-->
<!--					{{ $t('Изменить') }}-->
<!--				</b-button>&ndash;&gt;-->
<!--				&lt;!&ndash;<b-button-->
<!--					v-if="item.editable"-->
<!--					@click="showConfirm(item.id)"-->
<!--					variant="outline-danger"-->
<!--					:key="item.id + 'delete'"-->
<!--					:id="'popOverDelete'+item.id"-->
<!--				>-->
<!--					<i class="fa fa-trash"></i>-->
<!--					{{ $t('Delete') }}-->
<!--				</b-button>-->
<!--				<b-popover-->
<!--					:key="item.id + 'popover'"-->
<!--					:target="'popOverDelete'+item.id"-->
<!--					placement="bottom"-->
<!--					:ref="'popover'+item.id"-->
<!--					class="refDeleteConfirm"-->
<!--				>-->
<!--					<template slot="title">-->
<!--						<b-button @click="closeConfirm(item.id)" class="close" aria-label="Close"-->
<!--								  style="margin-left: 5px">-->
<!--							<span class="d-inline-block" aria-hidden="true">&times;</span>-->
<!--						</b-button>-->
<!--						{{ $t('want_to_delete?') }}-->
<!--					</template>-->

<!--					<div>-->
<!--						<div class="row mt-1">-->
<!--							<div class="col-6">-->
<!--								<b-button variant="outline-danger" size="sm" block @click="closeConfirm(item.id)">-->
<!--									{{$t('actions.no') }}-->
<!--								</b-button>-->
<!--							</div>-->
<!--							<div class="col-6">-->
<!--								<b-button variant="outline-success" size="sm" block @click="remove">{{ $t('actions.yes') }}-->
<!--								</b-button>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</b-popover>&ndash;&gt;-->
<!--				&lt;!&ndash;<div class="pull-right ml-2 pt-2">-->
<!--					<b-form-group>-->
<!--						<b-form-checkbox-group switches disabled v-model="income" name="switches1"-->
<!--											   :options="[{text: 'Income', value: true}]"/>-->
<!--					</b-form-group>-->
<!--				</div>&ndash;&gt;-->
<!--				&lt;!&ndash;<div class="pull-right ml-2">-->
<!--					<b-form-group>-->
<!--						<b-form-radio-group-->
<!--							id="btnradios1"-->
<!--							buttons-->
<!--							v-model="priceType"-->
<!--							button-variant="outline-primary"-->
<!--							:options="[-->
<!--						{-->
<!--						text: 'Сум',-->
<!--						value: 'uzs'-->
<!--						},-->
<!--						{-->
<!--						text: 'USD',-->
<!--						value: 'usd'-->
<!--						},-->

<!--					]"-->
<!--							name="radiosBtnDefault"-->
<!--						/>-->
<!--					</b-form-group>-->
<!--				</div>-->
<!--				<div class="clearfix"></div>&ndash;&gt;-->
<!--			</div>-->
<!--			<div class="clearfix"></div>-->


<!--		</div>-->
<!--		<div class="doc-body">-->
<!--			<b-card class="p-3">-->
<!--				<div class="text-center mb-3">-->
<!--					<h4 class="font-weight-bold text-uppercase" style="color: blue;">АКТ СВЕРКИ <br>-->
<!--						<span class="small">расчеты с контрагентом по договору Договор №-->
<!--							<input placeholder="" type="text" class="bottomBorderedInput borderBlue"/> за период<br>-->
<!--							 {{ saldoByYear.currentYear.year }} г.-->
<!--						</span>-->
<!--					</h4>-->
<!--				</div>-->
<!--				<b-row class="mb-3">-->
<!--					<b-col cols="6" id="contragentInfo">-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>Адрес:</span>-->
<!--							<input-->
<!--								:value="currentContragentForTransfer.address"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>Телефон:</span>-->
<!--							<input-->
<!--								:value="currentContragentForTransfer.phone"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>ИНН:</span>-->
<!--							<input-->
<!--								:value="currentContragentForTransfer.inn"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>ОКОНХ:</span>-->
<!--							<input-->
<!--								:value="currentContragentForTransfer.okonx"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--					</b-col>-->
<!--					<b-col cols="6">-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>Адрес:</span>-->
<!--							<input-->
<!--								:value="currentDepartmentForMoneyTransfer.address"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>Телефон:</span>-->
<!--							<input-->
<!--								:value="currentDepartmentForMoneyTransfer.phone"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>ИНН:</span>-->
<!--							<input-->
<!--								:value="currentDepartmentForMoneyTransfer.inn"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--						<p class="saldoInfoTexts">-->
<!--							<span>ОКОНХ:</span>-->
<!--							<input-->
<!--								:value="currentDepartmentForMoneyTransfer.okonx"-->
<!--								placeholder=""-->
<!--								type="text"-->
<!--								class="bottomBorderedInput ml-1"/>-->
<!--						</p>-->
<!--					</b-col>-->
<!--				</b-row>-->
<!--				<b-row class="mb-3">-->
<!--					<b-col cols="12" id="saldoAktDefinition">-->
<!--						Мы, нижеподписавшиеся главный бухгалтер-->
<!--						<input-->
<!--							:value="currentDepartmentForMoneyTransfer.accountantFullName"-->
<!--							placeholder="" type="text"-->
<!--							class="bottomBorderedInput"-->
<!--							onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/>-->
<!--						<strong>{{currentDepartmentForMoneyTransfer.name }}</strong> с одной стороны, и-->
<!--						<strong>{{ currentContragentForTransfer.fullName }}</strong>-->
<!--						с другой стороны, составили настоящий акт-сверки на <input placeholder="" type="text"-->
<!--																				   class="bottomBorderedInput forDate borderDefault"-->
<!--																				   onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/>-->
<!--						{{ saldoByYear.currentYear.year }} г.-->
<!--					</b-col>-->
<!--				</b-row>-->
<!--				<div class="saldoTable mb-3">-->
<!--					<table class="table table-striped">-->
<!--						<thead>-->
<!--						<tr>-->
<!--							<th class="p-1" rowspan="2">{{$t('incomes.date')}}</th>-->
<!--							<th class="p-1" rowspan="2">Наименование операции</th>-->
<!--							<th class="p-1" colspan="2">{{ currentContragentForTransfer.fullName }}</th>-->
<!--							<th class="p-1" colspan="2">{{ currentDepartmentForMoneyTransfer ?-->
<!--								currentDepartmentForMoneyTransfer.name : ' '}}-->
<!--							</th>-->
<!--						</tr>-->
<!--						<tr>-->
<!--							<th class="p-1">Д-Т</th>-->
<!--							<th class="p-1">К-Т</th>-->
<!--							<th class="p-1">Д-Т</th>-->
<!--							<th class="p-1">К-Т</th>-->
<!--						</tr>-->
<!--						</thead>-->
<!--						<tbody>-->
<!--						<tr class="lastYear strong">-->
<!--							<td colspan="2">Сальдо на 31 декабрь {{ saldoByYear.lastYear.year }} г.</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.lastYear.debitContragent">-->
<!--									{{ saldoByYear.lastYear.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.lastYear.creditContragent">-->
<!--									{{ saldoByYear.lastYear.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.lastYear.debitDepartment">-->
<!--									{{ saldoByYear.lastYear.debitDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.lastYear.creditDepartment">-->
<!--									{{ saldoByYear.lastYear.creditDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--						</tr>-->

<!--						<tr class="saldoList" v-for="el in saldoByYear.saldoList">-->
<!--							<td>{{ el.aktDate }}</td>-->
<!--							<td>{{ el.operation }}</td>-->
<!--							<td>-->
<!--								<span v-if="el.debitContragent">-->
<!--									{{ el.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="el.creditContragent">-->
<!--									{{ el.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="el.debitDepartment">-->
<!--									{{ el.debitDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="el.creditDepartment">-->
<!--									{{ el.creditDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--						</tr>-->

<!--						<tr class="currentYear strong">-->
<!--							<td colspan="2">Обороты за период {{ saldoByYear.currentYear.year }} г.</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.currentYear.debitContragent">-->
<!--									{{ saldoByYear.currentYear.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.currentYear.creditContragent">-->
<!--									{{ saldoByYear.currentYear.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.currentYear.debitDepartment">-->
<!--									{{ saldoByYear.currentYear.debitDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.currentYear.creditDepartment">-->
<!--									{{ saldoByYear.currentYear.creditDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--						</tr>-->

<!--						<tr class="totalSaldo strong">-->
<!--							<td colspan="2">Сальдо конечное {{ saldoByYear.totalSaldo.year }} г.</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.totalSaldo.debitContragent">-->
<!--									{{ saldoByYear.totalSaldo.debitContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.totalSaldo.creditContragent">-->
<!--									{{ saldoByYear.totalSaldo.creditContragent | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.totalSaldo.debitDepartment">-->
<!--									{{ saldoByYear.totalSaldo.debitDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--							<td>-->
<!--								<span v-if="saldoByYear.totalSaldo.creditDepartment">-->
<!--									{{ saldoByYear.totalSaldo.creditDepartment | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}-->
<!--								</span>-->
<!--							</td>-->
<!--						</tr>-->
<!--						</tbody>-->
<!--					</table>-->
<!--				</div>-->
<!--				<div class="mb-3 mt-5">-->
<!--					<div class="d-flex" style="color: red;">-->
<!--						<p class=""><strong>Сальдо на <input placeholder="" type="text"-->
<!--															 class="bottomBorderedInput forDate borderRed"-->
<!--															 onkeypress="this.style.width = ((this.value.length + 1) * 8) + 'px';"/> {{ saldoByYear.currentYear.year }} г. в-->
<!--							сумме <br>-->
<!--							В пользу : {{ inFavorWhom }} </strong></p>-->
<!--					</div>-->
<!--				</div>-->
<!--				<b-row class="mb-3">-->
<!--					<b-col cols="6" class="signsOfAccountants">-->
<!--						<p><strong>Главный бухгалтер</strong></p>-->
<!--						<input-->
<!--							placeholder=""-->
<!--							type="text"-->
<!--							class="bottomBorderedInput"/>-->
<!--						<p class="sign"><i>подпись</i></p>-->
<!--					</b-col>-->
<!--					<b-col cols="6" class="signsOfAccountants">-->
<!--						<p><strong>Главный бухгалтер</strong></p>-->
<!--						<input-->
<!--							placeholder=""-->
<!--							type="text"-->
<!--							class="bottomBorderedInput"/>-->
<!--						<p class="sign"><i>подпись</i></p>-->
<!--					</b-col>-->
<!--				</b-row>-->
<!--			</b-card>-->
<!--		</div>-->
<!--		&lt;!&ndash;<vs-sidebar :click-not-close="true"-->
<!--					position-right-->
<!--					parent="body"-->
<!--					default-index="1"-->
<!--					color="primary"-->
<!--					class="create-modal"-->
<!--					spacer-->
<!--					v-model="sidebar.open">-->
<!--			<b-container index="1" v-if="sidebar.open">-->
<!--				<create-form-->
<!--					:mode="'edit'"-->
<!--					:edit-item="item"-->
<!--					@close="sidebar.open = false"-->
<!--					@reload="get"-->
<!--				></create-form>-->
<!--			</b-container>-->
<!--		</vs-sidebar>&ndash;&gt;-->
<!--	</b-container>-->
<!--</template>-->

<!--<script>-->
<!--import TokenService from "../../../services/storage.service";-->
<!--// import moment from 'moment'-->
<!--import {mapState} from 'vuex'-->
<!--// import CreateForm from "../blocks/CreateForm";-->
<!--export default {-->
<!--	name: 'ShowSaldo',-->

<!--	data() {-->
<!--		return {-->
<!--			item: {},-->
<!--			totalPrice: {-->
<!--				uzs: 0,-->
<!--				usd: 0-->
<!--			},-->
<!--			priceType: 'uzs',-->
<!--			income: [],-->
<!--			totalIncome: {-->
<!--				uzs: 0,-->
<!--				usd: 0-->
<!--			},-->
<!--			sidebar: {-->
<!--				open: false,-->
<!--				close: false-->
<!--			},-->
<!--			backTo: null,-->
<!--		}-->
<!--	},-->
<!--	beforeRouteEnter (to, from, next) {-->
<!--		if(localStorage.getItem('isContragent')) {-->
<!--			if(to.params.id == localStorage.getItem('contragent_id') ){-->
<!--				next()-->
<!--			}else {-->
<!--				next('/dashboard')-->
<!--			}-->
<!--		}else {-->
<!--			next()-->
<!--		}-->
<!--	},-->
<!--	methods: {-->
<!--		/*get() {-->
<!--			if (this.$can('get', 'warehouse-document')) {-->
<!--				/!*return WhDocument.get(this.$route.params.id).then(response => {-->
<!--					this.item = response.data;-->
<!--					this.sumPrice(this.item);-->
<!--					this.sumIncome(this.item);-->
<!--				})*!/-->
<!--			}-->
<!--		},*/-->
<!--		/*sumPrice(item) {-->
<!--			if (typeof item.whItems === 'object') {-->
<!--				Object.values(item.whItems).map(item => {-->
<!--					if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;-->
<!--					if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;-->
<!--				});-->
<!--			}-->
<!--		},*/-->
<!--		/*sumIncome(item) {-->
<!--			if (typeof item.whItems === 'object') {-->
<!--				Object.values(item.whItems).map(item => {-->
<!--					this.totalIncome.usd += item.incomingPriceUsd * item.count;-->
<!--					this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;-->
<!--				});-->
<!--			}-->
<!--		},*/-->
<!--		/*formatDate(date, format = 'DD-MM-YYYY') {-->
<!--			if (date) {-->
<!--				const split = date.split(' ');-->
<!--				date = split[0];-->
<!--				const revers = date.split('-');-->
<!--				date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';-->
<!--				return moment(String(date)).format(format)-->
<!--			}-->
<!--		},*/-->
<!--		goBackToFrom() {-->
<!--			this.$router.back();-->
<!--		},-->
<!--		print() {-->
<!--			window.print();-->
<!--		},-->
<!--		/*openSidebar() {-->
<!--			setTimeout(() => {-->
<!--				this.sidebar.open = true-->
<!--			}, 200)-->
<!--		},*/-->

<!--		/*generateBarcode() {-->
<!--			this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);-->
<!--		},*/-->

<!--		/*remove() {-->
<!--			/!*WhDocument.remove(this.item.id).then(response => {-->
<!--				this.$router.push('/warehouse-management/income');-->
<!--			})*!/-->
<!--		},*/-->

<!--		/*showConfirm(item) {-->
<!--			let refName = 'popover' + item;-->
<!--			this.$refs[refName].$emit('open')-->
<!--		},*/-->
<!--		/*closeConfirm(item) {-->
<!--			let refName = 'popover' + item;-->
<!--			this.$refs[refName].$emit('close')-->
<!--		},*/-->
<!--		/*excelExport(tableID, filename = '') {-->

<!--			let downloadLink;-->

<!--			let dataType = 'text/xls;charset=UTF-8';-->
<!--			//var dataType = 'application/vnd.ms-excel';-->
<!--			let tableSelect = document.getElementById(tableID);-->
<!--			let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');-->

<!--			// Specify file name-->
<!--			filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';-->
<!--			// Create download link element-->
<!--			downloadLink = document.createElement("a");-->

<!--			document.body.appendChild(downloadLink);-->

<!--			if (navigator.msSaveOrOpenBlob) {-->
<!--				let blob = new Blob(['\ufeff', tableSelect], {-->
<!--					encoding: "utf-8",-->
<!--					type: dataType-->
<!--				});-->
<!--				navigator.msSaveOrOpenBlob(blob, filename);-->
<!--			} else {-->
<!--				// Create a link to the file-->
<!--				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;-->

<!--				// Setting the file name-->
<!--				downloadLink.download = filename;-->

<!--				//triggering the function-->
<!--				downloadLink.click();-->
<!--			}-->

<!--		},*/-->


<!--	},-->
<!--	created() {-->
<!--	},-->
<!--	computed: {-->
<!--		...mapState('contragents', [-->
<!--			'saldoByYear',-->
<!--			'currentDepartmentForMoneyTransfer',-->
<!--			'currentContragentForTransfer'-->
<!--		]),-->
<!--		inFavorWhom() {-->
<!--			if (this.saldoByYear.totalSaldo.debitContragent) {-->
<!--				return this.currentContragentForTransfer.fullName;-->
<!--			} else if (this.saldoByYear.totalSaldo.debitDepartment) {-->
<!--				return this.currentDepartmentForMoneyTransfer.name;-->
<!--			} else {-->
<!--				return ''-->
<!--			}-->
<!--		},-->
<!--	},-->
<!--	components: {},-->
<!--}-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--@media print {-->
<!--	.hidden-print {-->
<!--		display: none;-->
<!--	}-->

<!--	.card {-->
<!--		box-shadow: none;-->
<!--	}-->
<!--}-->

<!--.saldoInfoTexts {-->
<!--	width: 88%;-->

<!--	span {-->
<!--		display: inline-block;-->
<!--		width: 18%;-->
<!--	}-->

<!--	input.bottomBorderedInput {-->
<!--		outline: 0;-->
<!--		border-width: 0 0 .5px;-->
<!--		border-color: black;-->
<!--		width: 80%;-->
<!--	}-->

<!--	/*input.bottomBorderedInput:focus {-->
<!--	border-color: green-->
<!--	}*/-->
<!--}-->

<!--.signsOfAccountants {-->
<!--	input.bottomBorderedInput {-->
<!--		outline: 0;-->
<!--		border-width: 0 0 .5px;-->
<!--		border-color: black;-->
<!--		width: 40%;-->
<!--	}-->

<!--	p {-->
<!--		width: 40%;-->

<!--		&.sign {-->
<!--			text-align: center;-->
<!--			font-size: 12px;-->
<!--		}-->
<!--	}-->
<!--}-->

<!--input.bottomBorderedInput {-->
<!--	outline: 0;-->
<!--	border-width: 0 0 .5px;-->
<!--	border-color: black;-->

<!--	&.borderBlue {-->
<!--		width: 70px;-->
<!--		border-color: blue;-->
<!--		color: blue;-->
<!--	}-->

<!--	&.forDate {-->
<!--		width: 40px;-->
<!--		text-align: right;-->

<!--		&.borderRed {-->
<!--			border-color: red;-->
<!--			color: red;-->
<!--		}-->
<!--	}-->
<!--}-->

<!--.saldoTable {-->
<!--	.table {-->
<!--		td, th {-->
<!--			text-align: center;-->
<!--			vertical-align: middle;-->
<!--		}-->

<!--		th {-->
<!--			font-size: 14px;-->
<!--		}-->

<!--		td {-->
<!--			font-size: 12px;-->
<!--		}-->
<!--	}-->
<!--}-->

<!--.strong {-->
<!--	font-weight: bold;-->
<!--}-->

<!--</style>-->
